import { Link, useRouterState } from "@tanstack/react-router";
import { TreeIcon, BriefcaseIcon } from "@/components/icons/ModeIcons";
import { AutoT } from "@/i18n/AutoT";

/**
 * Compact Explore ↔ Business mode switch designed for the desktop header.
 * Sits inline with the top nav and uses real routes so the mode is
 * shareable, SSR-rendered and indexable.
 */
export function HeaderModeSwitch() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const mode = pathname.startsWith("/business") ? "business" : "explore";

  const base =
    "group relative inline-flex items-center justify-center gap-2 rounded-full px-4 py-2 text-[13px] font-semibold transition-all duration-200";

  return (
    <div className="hidden items-center">
      <div
        className="flex items-center gap-1 rounded-full bg-slate-100/90 p-1 ring-1 ring-navy/10 shadow-sm"
        role="tablist"
        aria-label="Site mode"
      >
        <Link
          to="/"
          role="tab"
          aria-selected={mode === "explore"}
          className={`${base} ${
            mode === "explore"
              ? "bg-navy text-white shadow-[0_2px_8px_-2px_rgba(15,30,60,0.35)]"
              : "text-navy/70 hover:text-navy hover:bg-navy/5"
          }`}
          style={{ textTransform: "none" }}
        >
          <TreeIcon className="size-3.5" />
          <AutoT text="Explore" />
        </Link>

        <Link
          to="/business"
          role="tab"
          aria-selected={mode === "business"}
          className={`${base} ${
            mode === "business"
              ? "bg-navy text-white shadow-[0_2px_8px_-2px_rgba(15,30,60,0.35)]"
              : "text-navy/70 hover:text-navy hover:bg-navy/5"
          }`}
          style={{ textTransform: "none" }}
        >
          <BriefcaseIcon className="size-3.5" />
          <AutoT text="Business" />
        </Link>
      </div>
    </div>
  );
}
